import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { PaymentRefundTarget } from '../api/types/paymentRefunds.types';

import {
  paymentRefundTargetKey,
  fetchPaymentRefundOptions,
} from '../api/paymentRefunds.api';

/**
 * T6 (D9) — one store for both targets.
 *
 * The key is the ORGANIZATION plus the target's own identity, never the
 * charge ids inside the answer: the whole point of the read is that the set of
 * refundable charges can move (a reservation, a provider confirmation), and a
 * key derived from it would never invalidate. Scoping by organization also
 * keeps the shared prefix usable as an invalidation handle when a refund lands
 * somewhere else in the same organization.
 */
export const paymentRefundsQueryKeys = createQueryKeys('paymentRefunds', {
  fetchOptions: (target: PaymentRefundTarget) => ({
    queryFn: () => fetchPaymentRefundOptions(target),
    queryKey: paymentRefundTargetKey(target),
  }),
});
